<!-- 列表 -->
<SiteDiary-List *ngIf="!displayTemplate" (listItemButton)="listItemClick()" [displayTemplate]="displayTemplate" [currentPage]="currentPage" [oldAction]="action"></SiteDiary-List>
<!-- 点击列表edit按钮的页面 -->
<SiteDiary-Details *ngIf="displayTemplate=='edit' || displayTemplate == 'copy'" (submitButton)="listItemClick()"></SiteDiary-Details>